import { Heart, MessageCircle, Link as LinkIcon } from "@/components/icons/outline"
import CreateReply from "@/components/partials/create-reply"
import DeletePost from "@/components/partials/delete-post"
import DeleteReply from "@/components/partials/delete-reply"
import EditPost from "@/components/partials/edit-post"
import EditReply from "@/components/partials/edit-reply"
import { useAuth } from "@/contexts/auth-context"

import Main from "@/layouts/main"
import usePostDetailRepos from "@/repositories/post-detail"
import axios from "axios"
import moment from "moment"
import { useState } from "react"
import toast from "react-hot-toast"
import { useNavigate, useParams } from "react-router-dom"

export default function Detail() {
    // Hooks
    // const [data, setData] = useState(useLoaderData())
    const navigate = useNavigate()
    const { id } = useParams()

    // Contexts
    const { user, token } = useAuth()

    // Data
    const { data: data, isLoading: isLoadingPostData, mutate: mutatePostData } = usePostDetailRepos(id)

    const toggleLikePost = () => {
        var temp = data

        const baseUrl = process.env.REACT_APP_API_URL

        if (temp.likePost.find((row) => row.userId === user?.id)) {
            temp.likePost = temp.likePost.filter((row) => row.userId !== user?.id)
            temp._count.likePost--

            axios.delete(`${baseUrl}/posts/${data.id}/like`, { headers: { Authorization: `Bearer ${token}` } })
        } else {
            temp.likePost.push({ userId: user?.id, postId: data?.id })
            temp._count.likePost++

            axios.post(`${baseUrl}/posts/${data.id}/like`, {}, { headers: { Authorization: `Bearer ${token}` } })
        }

        mutatePostData(temp, { optimisticData: true, revalidate: false })
    }

    const updatePost = (value) => {
        mutatePostData({ ...data, content: value }, { optimisticData: true })
    }

    const updateReply = (value) => {
        const updatedReplyData = data.reply.map((row) => {
            if (row.id === value.id) {
                row.content = value.content
            }

            return row
        })

        mutatePostData({ ...data, reply: updatedReplyData }, { optimisticData: true })
    }

    const deleteReply = (value) => {
        const updatedReplyData = data.reply.filter((row) => row.id !== value.id)

        mutatePostData({ ...data, reply: updatedReplyData }, { optimisticData: true })
    }

    return (
        <Main title="Detail" headerTitle="Post Detail" showBackButton>
            <div className="divide-y">
                <div key={data.id} className="flex flex-col w-full p-6 space-y-6">
                    <div className="flex flex-col justify-between w-full space-y-4 md:flex-row md:space-y-0">
                        <div className="flex space-x-4">
                            <div className="relative">
                                <img className="w-10 h-10 rounded-xl" src={`https://ui-avatars.com/api/?name=${data.user?.name}`} alt={`${data.user?.name}'s Profile Picture`} />
                            </div>
                            <div className="flex flex-col items-start justify-between">
                                {/* Name */}
                                <p className="inline-flex items-center text-sm font-semibold">{data.user?.name} <span className="ml-1 text-xs text-neutral-500">{data.user?.role?.name}</span></p>
                                {/* Timestamp */}
                                <p className="text-xs text-neutral-500">{moment(data.createdAt).fromNow()}</p>
                            </div>
                        </div>
                        <div className="px-3 py-1 text-xs font-medium text-blue-500 bg-blue-100 border border-blue-500 rounded-full h-fit w-fit">{data.category?.name}</div>
                    </div>
                    {/* Content */}
                    <div className="text-sm">
                        {data.content}
                    </div>
                    <div className="flex items-center justify-between w-full text-sm text-neutral-500">
                        <div className="flex items-center space-x-8">
                            {/* Likes */}
                            <button onClick={() => toggleLikePost()} className="flex items-center space-x-2 z-1">
                                <Heart className={`${!isLoadingPostData && data.likePost.find((row) => row.userId === user?.id) ? 'text-red-500' : ''}`} fill={`${!isLoadingPostData && data.likePost.find((row) => row.userId === user?.id) ? 'currentColor' : 'none'}`} />
                                <span>
                                    <p>{data._count?.likePost ?? 0}</p>
                                </span>
                            </button>
                            {/* Reply */}
                            <CreateReply data={{ post: data }} label={data.reply?.length ?? 0} onSubmit={() => mutatePostData()} />
                        </div>
                        <div className="flex items-center space-x-8">
                            {/* Copy Link */}
                            <button onClick={() => navigator.clipboard.writeText(`${process.env.REACT_APP_URL}/post/${data.id}`)}>
                                <LinkIcon />
                            </button>
                            {/* Edit Post */}
                            {data.userId === user?.id && (
                                <EditPost data={data} onSubmit={(value) => updatePost(value)} />
                            )}
                            {/* Delete Post */}
                            {data.userId === user?.id && (
                                <DeletePost data={data} onSubmit={() => navigate('/')} />
                            )}
                        </div>
                    </div>
                </div>

                {/* Replies */}
                {data.reply?.map((row) => (
                    <div key={row.id} className="flex flex-col w-full p-6 space-y-6">
                        <div className="flex justify-between w-full">
                            <div className="flex space-x-4">
                                <div className="relative">
                                    <img className="w-10 h-10 rounded-xl" src={`https://ui-avatars.com/api/?name=${row.user?.name}`} alt={`${row.user?.name}'s Profile Picture`} />
                                </div>
                                <div className="flex flex-col items-start justify-between">
                                    {/* Name */}
                                    <p className="inline-flex items-center text-sm font-semibold">{row.user?.name} <span className="ml-1 text-xs text-neutral-500">{row.user?.role?.name}</span></p>
                                    {/* Timestamp */}
                                    <p className="text-xs text-neutral-500">{moment(row.createdAt).fromNow()}</p>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col items-start space-y-2">
                            {/* Content */}
                            <div className="text-sm">
                                {row.content}
                            </div>
                            {row.createdAt != row.updatedAt && (<p className="text-xs font-semibold text-neutral-400">Edited</p>)}
                        </div>
                        <div className="flex items-center justify-between w-full text-sm text-neutral-500">
                            <div className="flex items-center space-x-8">
                                {/* Likes */}
                                {/* <button onClick={() => toggleLikeReply(row.id)} className="flex items-center space-x-2 z-1">
                                    <Heart className={`${!isLoadingPostData && data.likePost.find((row) => row.userId === user?.id) ? 'text-red-500' : ''}`} fill={`${!isLoadingPostData && data.likePost.find((row) => row.userId === user?.id) ? 'currentColor' : 'none'}`} />
                                    <span>
                                        <p>{data._count?.likePost ?? 0}</p>
                                    </span>
                                </button> */}
                            </div>
                            <div className="flex items-center space-x-8">
                                {/* Edit Reply */}
                                {row.userId === user?.id && (
                                    <EditReply data={{ post: data, reply: row }} onSubmit={(value) => updateReply(value)} />
                                )}
                                {/* Delete Reply */}
                                {row.userId === user?.id && (
                                    <DeleteReply data={{ post: data, reply: row }} onSubmit={(value) => deleteReply(value)} />
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </Main>
    )
}